import * as Sentry from '@sentry/react';
import { redirect, type LoaderFunctionArgs } from 'react-router';
import { apiClient } from 'shared/api-client';
import * as v from 'valibot';

import routes from '@/assets/constants/routes-no';
import { getLiveOffersUrlQuery } from '@/lib/api/queries';
import { queryClient } from '@/queryClient';

const ApplicationSimpleSchema = v.object({
  id: v.number(),
  live_offers_recording_url: v.string(),
});

export const liveOffersPreviewLoader = async ({
  params,
}: LoaderFunctionArgs) => {
  try {
    if (!params.web_rec_id) {
      throw new Error('Web rec id is required');
    }

    queryClient.prefetchQuery(
      getLiveOffersUrlQuery({
        webRecId: +params.web_rec_id,
        source: 'LIVE_OFFERS_PREVIEW',
      }),
    );

    const res = await apiClient
      .get(`loans/applications/${params.web_rec_id}/`)
      .json();

    return v.parse(ApplicationSimpleSchema, res);
  } catch (error) {
    const err = new Error('Failed to load live offers preview', {
      cause: error,
    });
    Sentry.captureException(err);
    console.error(err);
    throw redirect(routes.ERROR_PAGE);
  }
};

export type LiveOffersPreviewLoaderData = Awaited<
  ReturnType<typeof liveOffersPreviewLoader>
>;
